module.exports = __webpack_public_path__ + "img/图1-1图样.698afc2d.png";